import { ReturnStatus } from 'themes/types';
import { SYSTEM_COLORS } from '../system-colors';

export const RETURN_STATUS: ReturnStatus = {
  returnStatus: {
    default: {
      primary: SYSTEM_COLORS.neutral_200,
      secondary: SYSTEM_COLORS.neutral_500,
    },
    CREATED: {
      primary: SYSTEM_COLORS.warning_200,
      secondary: SYSTEM_COLORS.neutral_700,
    },
    WAIT_CUSTOMER: {
      primary: SYSTEM_COLORS.success_200,
      secondary: SYSTEM_COLORS.neutral_500,
    },
    AWAITING_CUSTOMER_SHIPMENT: {
      primary: SYSTEM_COLORS.success_200,
      secondary: SYSTEM_COLORS.neutral_500,
    },
    AWAITING_CUSTOMER_DROPOFF: {
      primary: SYSTEM_COLORS.success_200,
      secondary: SYSTEM_COLORS.neutral_500,
    },
    WAIT: {
      primary: SYSTEM_COLORS.success_200,
      secondary: SYSTEM_COLORS.neutral_500,
    },
    AWAITING_PRODUCT_ARRIVAL: {
      primary: SYSTEM_COLORS.success_200,
      secondary: SYSTEM_COLORS.neutral_500,
    },
    PRODUCT_RECEIVED: {
      primary: SYSTEM_COLORS.success_300,
      secondary: SYSTEM_COLORS.neutral_100,
    },
    RECEIVED: {
      primary: SYSTEM_COLORS.success_300,
      secondary: SYSTEM_COLORS.neutral_100,
    },
    RETURN_CONFIRMED: {
      primary: SYSTEM_COLORS.success_300,
      secondary: SYSTEM_COLORS.neutral_100,
    },
    RECEIVED_CONFIRMED: {
      primary: SYSTEM_COLORS.success_300,
      secondary: SYSTEM_COLORS.neutral_100,
    },
    REFUND_ERROR: {
      primary: SYSTEM_COLORS.danger_300,
      secondary: SYSTEM_COLORS.neutral_100,
    },
    COMPLETED: {
      primary: SYSTEM_COLORS.success_500,
      secondary: SYSTEM_COLORS.neutral_100,
    },
    REFUNDED: {
      primary: SYSTEM_COLORS.success_500,
      secondary: SYSTEM_COLORS.neutral_100,
    },
    REFUND_FAILED: {
      primary: SYSTEM_COLORS.success_500,
      secondary: SYSTEM_COLORS.neutral_100,
    },
    CANCELED: {
      primary: SYSTEM_COLORS.danger_300,
      secondary: SYSTEM_COLORS.neutral_100,
    },
  },
};
